import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { CurrencyInput } from 'ui-components/components/currency-input';

import { useAddFundsModalContext } from './contexts/add-funds-modal-context-provider';
import AddFundsErrorSection from './error-section';
import messages from './messages';
import style from './style.module.less';
import FormattedCurrency from '../../../../components/formatted-currency';
import PhoneVerificationBanner from '../../../../components/phone-verification/banner-message';
import { PhoneVerificationContext } from '../../../../components/phone-verification/context';
import { CurrencyPropType } from '../../../../prop-types/currency';

const AddFundsTab = ({ allowDefaultPurchase = false, balance }) => {
  const { fundAmount, setFundAmount, useAsDefault, setUseAsDefault, addFundErrors: errors, submitting } = useAddFundsModalContext();
  const { providerIdRequiringPhoneVerification } = useContext(PhoneVerificationContext);
  const toggleUseAsDefault = useCallback(() => setUseAsDefault((val) => !val), [setUseAsDefault]);

  return (
    <div className={style['tab-content']}>
      {errors?.length > 0 && !providerIdRequiringPhoneVerification && <AddFundsErrorSection currencyCode={balance?.code} errors={errors} />}
      {providerIdRequiringPhoneVerification ? (
        <PhoneVerificationBanner sellerLabelProviderId={providerIdRequiringPhoneVerification} />
      ) : null}
      <div className={style.label}>
        <FormattedMessage {...messages.currentBalance} />
      </div>
      {balance ? <FormattedCurrency currencyCode={balance?.code} value={balance?.value} /> : <span>&mdash;</span>}
      <div className={style.label}>
        <FormattedMessage {...messages.amountToAdd} />
      </div>
      <CurrencyInput
        className={style['currency-funds']}
        currencyCode={balance?.code}
        disabled={submitting}
        onChange={setFundAmount}
        value={fundAmount}
      />
      {allowDefaultPurchase ? (
        <Checkbox
          checked={useAsDefault}
          className={style['make-default-checkbox']}
          disabled={submitting}
          inputId='make-default-checkbox'
          label={<FormattedMessage {...messages.makeDefault} />}
          largeCheckbox
          onChange={toggleUseAsDefault}
        />
      ) : null}
    </div>
  );
};

AddFundsTab.propTypes = {
  allowDefaultPurchase: PropTypes.bool,
  balance: CurrencyPropType.isRequired,
};

export default AddFundsTab;
